import React, { useState, useEffect, useRef } from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";

const images = [
  "https://img.freepik.com/free-photo/strong-man-training-gym_1303-23478.jpg?semt=ais_hybrid&w=740&q=80",
  "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg?cs=srgb&dl=pexels-willpicturethis-1954524.jpg&fm=jpg",
  "https://img.freepik.com/free-photo/view-gym-room-training-sports_23-2151699540.jpg?semt=ais_hybrid&w=740&q=80",
  "https://png.pngtree.com/thumb_back/fh260/background/20240329/pngtree-rows-of-dumbbells-in-the-gym-image_15662386.jpg",
  "https://img.freepik.com/premium-photo/gym-equipment-dark-gym-with-barbells-rack-fitness-workout-center-sport-concept_175682-11916.jpg",
  "https://www.fitness-world.in/wp-content/uploads/2022/01/Planning-to-Install-a-Gym-in-your-Society-Banner-1200x620.jpg",
  "https://www.diamondfitnesspro.com/wp-content/uploads/2024/11/DERC-GYM-1-1024x731.jpg",
  "https://img.freepik.com/free-photo/strong-man-training-gym_1303-23876.jpg?semt=ais_hybrid&w=740&q=80"
];

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const lightboxRef = useRef(null);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const changeImage = (step) => {
    setCurrentIndex((prevIndex) => {
      let newIndex = prevIndex + step;

      if (newIndex < 0) newIndex = images.length - 1;
      if (newIndex >= images.length) newIndex = 0;

      return newIndex;
    });
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      if (e.key === "ArrowLeft") changeImage(-1);
      if (e.key === "ArrowRight") changeImage(1);
      if (e.key === "Escape") closeLightbox();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  // Close lightbox on clicking outside image
  const handleOutsideClick = (e) => {
    if (e.target === lightboxRef.current) closeLightbox();
  };

  return (
    <Template>
      <BreadCrumb pageName="Our Gallery" />
      <section className="section-lgx">
        <div className="container">
          {/* Gallery */}
          <div className="gallery">
            {images.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Gallery Image ${index + 1}`}
                onClick={() => openLightbox(index)}
              />
            ))}
          </div>

          {/* Lightbox */}
          {isOpen && (
            <div
              id="lightbox"
              className="lightbox"
              ref={lightboxRef}
              onClick={handleOutsideClick}
              style={{ display: "flex" }} // keep same styling
            >
              <span className="close" onClick={closeLightbox}>
                &times;
              </span>

              <span className="prev" onClick={() => changeImage(-1)}>
                &#10094;
              </span>

              <img
                id="lightbox-img"
                src={images[currentIndex]}
                alt="Lightbox"
              />

              <span className="next" onClick={() => changeImage(1)}>
                &#10095;
              </span>
            </div>
          )}
        </div>
      </section>
    </Template>
  );
}

export default Gallery;
